import { useState, useEffect, useContext } from 'react'
 // @ts-ignore
import io from 'socket.io-client'
import { AuthContext } from '@/layout/Auth'

export const useSocket = () => {
  const { authInfo } = useContext(AuthContext)
  const [socket, setSocket] = useState<unknown>()

  useEffect(() => {
    if (authInfo?.userInfo?.id && !socket) {
      const client = io('', {
        path: '/api/msg/ws',
        transports: ['websocket'],
        reconnectionAttempts: 3,
        query: {
          uid: authInfo?.userInfo?.id,
        },
        autoConnect: true,
      })
      setSocket(client)
    }
    //eslint-disable-next-line
  }, [authInfo?.userInfo?.id]);

  return socket
}
